import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
// import Style from 'ol/style/Style';
// import Text from 'ol/style/Text';
import { Draw, Modify, Snap } from 'ol/interaction';

import { filterDatalist, retrieveCode } from '../formal';
import { enrichInformation } from './feature-tools';
import { addLayerToList, addToPlanIdList, getListItemFromLayer } from '../list';
import { warn } from '../notify';
import { updatePopupFeature } from './popup';
import { planStyle } from './styles';
import { getLayerById } from './layer-tools';
import { idb } from './storage';
import { zoomToFeature } from './tools';
import { retrievePlanCategory } from '../util';
import * as _wizard from '../wizard';

const maxArea = 10000000; // dekar

const categoryToType = {
  Kommuneplan: 'KpArealformålOmråde',
  Reguleringsplan: 'RpArealformålOmråde',
  Nåværende: 'Nåværende',
  Fremtidig: 'Fremtidig'
};

const s = new VectorSource();
const drawings = new VectorLayer({
  properties: { id: 'drawings', label: 'tegning', type: 'drawings' },
  source: s,
  style: planStyle
});

let n = '@';
idb.getLayer('drawings').then(l => {
  const features = l.getSource().getFeatures();
  if (features.length < 1) return;
  s.addFeatures(features); // it should have been done silently, not to updLayer
  const li = getListItemFromLayer(drawings) || addLayerToList(drawings);
  features.forEach(f => {
    const c = f.get('feltnavn') || n;
    n = String.fromCharCode(Math.max(n.charCodeAt(), c.charCodeAt()));
  });
}).catch(e => console.log(e));

const draw = new Draw({ source: s, type: 'Polygon', stopClick: true });
const modify = new Modify({ source: s });
const snap = new Snap({ source: s })

// They do not change or do it too often:
// drawings.on('change:source', e => console.log('drawings change:source'));
// drawings.on('propertychange', e => console.log('drawings propertychange'));
// s.on('changefeature', e => console.log('s changefeature', e));
// s.on('propertychange', e => console.log('s propertychange'));

// s.on('addfeature', e => idb.updateLayer(drawings));
// s.on('removefeature', e => idb.updateLayer(drawings));
modify.on('modifyend', e => {
  e.features.forEach(updatePopupFeature);
  idb.updateLayer(drawings);
});

export const drawInitialization = (map) => {
  map.addInteraction(modify);
  map.addLayer(drawings);

  draw.on('drawend', (e) => {
    const f = e.feature;
    f.setId(f.ol_uid); // VectorSource#getFeatureById
    // console.log('drawend', f.getId());

    rightSize(f);

    n = String.fromCharCode(n.charCodeAt() + 1); // next character
    // f.setProperties({ id: f.ol_uid, title: 'Område ' + n });
    const planid = `Område ${n}`;
    const pk = retrievePlanCategory();
    const pt = pk ? categoryToType[pk] : 'Nåværende';
    // console.log(pk, pt);
    // To be able to use enrichInformation, we need:
    const p = {
      checked: true,
      drawn: true,
      feltbetegnelse: [n],
      NASJONALAREALPLANID: { planidentifikasjon: planid },
      objtype: pt
    };

    switch (pk) {
      case 'Fremtidig':
        p.fremtidig = fremtidig.value;
        const fcode = retrieveCode(fremtidig);
        p.arealformål = fcode;
        p.formål = fcode;
        break;
      case 'Kommuneplan':
      case 'Reguleringsplan':
        const code = retrieveCode(formål);
        p.arealformål = code;
        p.formål = code;
        break;
      default:
        // console.log('Nåværende');
    }

    f.setProperties(p);

    // f.setStyle(new Style({
    //   text : new Text({
    //     text: n, font: 'bold 24px sans-serif', overflow: true
    //   })
    // }));

    enrichInformation(f);
    if (!getLayerById('drawings')) map.addLayer(drawings);
    const li = getListItemFromLayer(drawings) || addLayerToList(drawings);
    addToPlanIdList({ planid, drawn: true }, drawings, li.querySelector('ul'));

    removeInteractions();

    idb.updateLayer(getLayerById('drawings'));
    _wizard.moveTo('home');
  });

  const addInteractions = () => {
    map.addInteraction(draw);
    // map.addInteraction(modify);
    map.addInteraction(snap);
  };

  const removeInteractions = () => {
    map.removeInteraction(draw);
    // map.removeInteraction(modify);
    map.removeInteraction(snap);
  };

  cancelDrawingBtn.onclick = () => {
    draw.abortDrawing();
    removeInteractions();
    _wizard.moveTo('home');
  };

  tegnBtn.onclick = () => {
    if (retrieveCode(formål)) formål.setCustomValidity('');
    else formål.setCustomValidity('Angi en verdi fra lista');
    if (retrieveCode(fremtidig)) fremtidig.setCustomValidity('');
    else fremtidig.setCustomValidity('Angi en verdi fra lista');
    const validForm = selection.checkValidity();
    if (validForm) {
      _wizard.moveTo('drawing');
      addInteractions();
    }
  };

};

export const rightSize = (f) => {
  const area = f.getGeometry().getArea();
  const dekar = Math.round(area / 1000);

  if (dekar > maxArea) {
    const a = dekar.toLocaleString('no-NO');
    const max = maxArea.toLocaleString('no-NO');
    const name = f.get('title') ? ` «${f.get('title')}»` : '';
    warn(`
      Området${name} er ${a} dekar. Maks størrelse er ${max} dekar.
      Endre området eller slett og tegn et mindre område.
    `);
    return false;
  }
  return true;
};

